import type React from 'react'
import type { JSX } from 'react'
import type { ICard } from '../../Card'

import { IconSizes } from 'atoms/Icon'
import { COLOR } from 'vars/color'
import { Card } from '../../Card'
import { CARDS_ASPECT_RATIO, CardAnimations } from '../../Card.h'
import { CardContent } from './MovieCardTemplate.styled'

export interface IMovieCardHLabelsText extends Omit<ICard, 'children'> {
  children: React.ReactNode
}

export const MovieCardHLabelsText = ({
  children,
  posterUrl,
  width = '100%',
  childrenTransition = CardAnimations.FadeIn,
  aspectRatio = CARDS_ASPECT_RATIO.HORIZONTAL_DEFAULT,
  viewedButtonFavorite = true,
  lockedSizeIcon = IconSizes.xxxLarge,
  backgroundColor = COLOR.SURFACE_DARK_6,
  lockedColor = COLOR.TEXT_ICON_PRIMARY,
  ...rest
}: IMovieCardHLabelsText): JSX.Element => {
  return (
    <Card
      posterUrl={posterUrl}
      width={width}
      childrenTransition={childrenTransition}
      aspectRatio={aspectRatio}
      backgroundColor={backgroundColor}
      lockedColor={lockedColor}
      lockedSizeIcon={lockedSizeIcon}
      {...rest}
    >
      <CardContent viewedButtonFavorite={viewedButtonFavorite}>
        {children}
      </CardContent>
    </Card>
  )
}
